const AUTHTOKEN_LOGOUT = "AUTHTOKEN_LOGOUT";
const USERS_REQUEST = "USERS_REQUEST";
const USERS_ERROR = "USERS_ERROR";
const USERS_SUCCESS = "USERS_SUCCESS";
const USERS_ITEMS_NEEDING_ATTENTION = "USERS_ITEMS_NEEDING_ATTENTION";
const USERS_ITEMS_SUCCESS = "USERS_ITEMS_SUCCESS";
const USERS_ITEMS_ERROR = "USERS_ITEMS_ERROR";
const USER_CHECKIN_RETRIEVE_ACTIVE = "USER_CHECKIN_RETRIEVE_ACTIVE"
const USER_CHECKIN_RETRIEVE_ACTIVE_SUCCESS = "USER_CHECKIN_RETRIEVE_ACTIVE_SUCCESS";
const USER_CHECKIN_RETRIEVE_ACTIVE_ERROR = "USER_CHECKIN_RETRIEVE_ACTIVE_ERROR";
const INDUCTIONS_REQUEST = 'INDUCTIONS_REQUEST';
const INDUCTIONS_SUCCESS = 'INDUCTIONS_SUCCESS'
const INDUCTIONS_ERROR = 'INDUCTIONS_ERROR'
const INDUCTIONS_SITE_REQUEST = 'INDUCTIONS_SITE_REQUEST';
const INDUCTIONS_USER_REQUEST = 'INDUCTIONS_USER_REQUEST';
const INDUCTION_CREATE = "INDUCTION_CREATE"
const INDUCTION_UPDATE = "INDUCTION_UPDATE"
const INDUCTION_DELETE = "INDUCTION_DELETE"

import Vue from "vue";

const state = { status: "", users: null, user: {}, items: [], inductions:[], usertypes: [
            {
                type: 1,
                name: 'VERNet NOC'
            },
            {
                type: 2,
                name: 'Field Technician'
            },
            {
                type: 3,
                name: 'VERNet Engineer'
            },
            {
                //Customer Admin
                type: 4,
                name: 'Admin'
            },
            {
                //Customer Standard User
                type: 5,
                name: 'Standard User'
            }
        ] };

const getters = {
    getUsers: state => state.users === null ? [] : state.users,
    searchUsers: (state) => searchParam => {
        if(!state.users){
            return []
        }

        var searchTerm = new RegExp(searchParam, "i")
        let fullNameArray = []
        let Results = []

        fullNameArray = searchParam.split(' ') //Splits search string by whitespace to check full names (Eg "Firstname Lastname")

        for(var word of fullNameArray){

            let testWord = new RegExp(word, "i")
            let testResults = state.users.filter(user => testWord.test(user.firstname) || testWord.test(user.surname))
            Results = Results.concat(testResults)
        }

        Results = Results.concat(state.users.filter((user => searchTerm.test(user.email) || searchTerm.test(user.title) || searchTerm.test(user.office) || searchTerm.test(user.mobile))))
        Results = [...new Set(Results.map(result => result))] //Clear out duplicate matches
        return Results
    },
    isUserListLoaded: state => !!state.users,
    isInductionListLoaded: state => !!state.inductions,
    getUser: (state)=> (userId) => {
        if(state.users === null){
            return {}
        } else return state.users.find(user => user.userid === userId)
    },
    getUsersByCustomer:(state)=> (custID) => {
        if(state.users === null){
            return []
        } else return state.users.filter(user => user.customerid === custID)
    },
    getUserType: (state) => (usertype) => {
        return state.usertypes.find((thisType) => thisType.type == usertype);
    },
    getUserTypes: (state) => (state.users === null ? [] : state.usertypes),
    getItems: state => (state.items ? state.items : []),
    getItemsSites:  (state) => {
        if(state.items === null){
            return []
        }

        var searchTerm = new RegExp("site", "i") //Events are searched by title, ticket number, description, and affected services
        return state.items.filter((item => searchTerm.test(item.notificationlinknode)))
    },
    getItemsServiceNotifications:  (state) => {
        if(state.items === null){
            return []
        }
        
        var searchTerm = new RegExp("notification", "i") //Events are searched by title, ticket number, description, and affected services
        return state.items.filter((item => searchTerm.test(item.notificationlinknode)))
    },
    getItemsInductions:  (state) => {
        if(state.items === null){
            return []
        }

        var searchTerm = new RegExp("site", "i") //Events are searched by title, ticket number, description, and affected services
        return state.items.filter((item => searchTerm.test(item.notificationlinknode)))
    },
};

const actions = {
    [USERS_REQUEST]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(USERS_REQUEST);
            commit('addLoading', {handle:'users',name:'Load Users'})



            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };

            fetch(Vue.prototype.$apiServer + 'users', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'users')
                        if (resp.result === 'Success') {
                            commit(USERS_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(USERS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERS_ERROR);
                    commit('removeLoading', 'users')
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })  
        })
    },
    [USERS_ITEMS_NEEDING_ATTENTION]: ({commit, dispatch}) => {
        return new Promise((resolve, reject) => {
            commit(USERS_ITEMS_NEEDING_ATTENTION);
            commit('addLoading', {handle:'useritems',name:'Load Items Needing Attention'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };

            fetch(Vue.prototype.$apiServer + 'itemsneedingattention', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'useritems')
                        if (resp.result === 'Success') {
                            commit(USERS_ITEMS_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(USERS_ITEMS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USERS_ITEMS_ERROR);
                    commit('removeLoading', 'useritems')
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })  
        })
    },
    [USER_CHECKIN_RETRIEVE_ACTIVE]: ({ commit, dispatch }, userid) => {
        return new Promise((resolve, reject) => {
            commit(USER_CHECKIN_RETRIEVE_ACTIVE);
            commit('addLoading', {handle:'usercheckinactive',name:'Load Users Check-Ins'})


            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };

            fetch(Vue.prototype.$apiServer + 'user/' + userid + '/checkins/active', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'usercheckinactive')
                        if (resp.result === 'Success') {
                            commit(USER_CHECKIN_RETRIEVE_ACTIVE_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(USER_CHECKIN_RETRIEVE_ACTIVE_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(USER_CHECKIN_RETRIEVE_ACTIVE_ERROR);
                    commit('removeLoading', 'usercheckinactive')
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            }) 
        })
    },
    [INDUCTIONS_REQUEST]: ({ commit, dispatch }) => {
        return new Promise((resolve, reject) => {
            commit(INDUCTIONS_REQUEST);
            commit('addLoading', {handle:'getInductions',name:'Load Inductions'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                //body: JSON.stringify(payload)
                //    body: JSON.stringify({})
            };

            fetch(Vue.prototype.$apiServer + 'inductions', loginDetails).then(response =>{
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        commit('removeLoading', 'getInductions')
                        if (resp.result === 'Success') {
                            commit(INDUCTIONS_SUCCESS, resp)
                            resolve(resp)
                        } else {
                            commit(INDUCTIONS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INDUCTIONS_ERROR);
                    commit('removeLoading', 'getInductions')
                    reject(response)
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    }                  
                }
            })  
        })
    },
    [INDUCTIONS_SITE_REQUEST]: ({ commit, dispatch }, siteid) => {
        return new Promise((resolve, reject) => {
            commit(INDUCTIONS_SITE_REQUEST);
            commit('addLoading', {handle:'siteInductions',name:'Loading Site Inductions'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'site/' + siteid + '/inductions', loginDetails).then(response =>{
                commit('removeLoading', 'siteInductions')
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            commit(INDUCTIONS_SUCCESS)
                            resolve(resp.payload)
                        } else {
                            commit(INDUCTIONS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INDUCTIONS_ERROR);
                    commit('removeLoading', 'siteInductions')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [INDUCTIONS_USER_REQUEST]: ({ commit, dispatch }, userid) => {
        return new Promise((resolve, reject) => {
            commit(INDUCTIONS_USER_REQUEST);
            commit('addLoading', {handle:'userInductions',name:'Loading User Inductions'})

            let loginDetails = {
                method: 'GET',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'user/' + userid + '/inductions', loginDetails).then(response =>{
                commit('removeLoading', 'userInductions')
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            commit(INDUCTIONS_SUCCESS)
                            resolve(resp.payload)
                        } else {
                            commit(INDUCTIONS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INDUCTIONS_ERROR);
                    commit('removeLoading', 'userInductions')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [INDUCTION_CREATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(INDUCTION_CREATE);
            commit('addLoading', {handle:'inductionCreate',name:'Creating Site Induction'})

            let loginDetails = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'induction' + payload.suffix, loginDetails).then(response =>{
                commit('removeLoading', 'inductionCreate')
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            commit(INDUCTIONS_SUCCESS)
                            resolve(resp.payload)
                        } else {
                            commit(INDUCTIONS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INDUCTIONS_ERROR);
                    commit('removeLoading', 'inductionCreate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [INDUCTION_UPDATE]: ({ commit, dispatch }, payload) => {
        return new Promise((resolve, reject) => {
            commit(INDUCTION_UPDATE);
            commit('addLoading', {handle:'inductionUpdate',name:'Updating Site Induction'})

            let loginDetails = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
                body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'induction/' + payload.inductionid, loginDetails).then(response =>{
                commit('removeLoading', 'inductionUpdate')
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            commit(INDUCTIONS_SUCCESS)
                            resolve(resp.payload)
                        } else {
                            commit(INDUCTIONS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INDUCTIONS_ERROR);
                    commit('removeLoading', 'inductionUpdate')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
    [INDUCTION_DELETE]: ({ commit, dispatch }, inductionid) => {
        return new Promise((resolve, reject) => {
            commit(INDUCTION_DELETE);
            commit('addLoading', {handle:'inductionDelete',name:'Deleting Site Induction'})

            let loginDetails = {
                method: 'DELETE',
                headers: { 'Content-Type': 'application/json', 'X-Auth-Token': Vue.prototype.$token },
            //    body: JSON.stringify(payload)
            };
                        
            fetch(Vue.prototype.$apiServer + 'induction/' + inductionid, loginDetails).then(response =>{
                commit('removeLoading', 'inductionDelete')
                if(response.ok){ //Successful response and payload
                    response.json().then(resp => {
                        if (resp.result === 'Success') {
                            commit(INDUCTIONS_SUCCESS)
                            resolve(resp.payload)
                        } else {
                            commit(INDUCTIONS_ERROR)
                            reject(resp)
                        }
                    })
                } else { //Error
                    commit(INDUCTIONS_ERROR);
                    commit('removeLoading', 'inductionDelete')
                    if (response.status == '403') {
                        dispatch(AUTHTOKEN_LOGOUT);
                    } 
                    response.json().then(err => {
                        reject(err)
                    })            
                }
            })
        })
    },
};

const mutations = {
    [USERS_REQUEST]: state => {
        state.status = "loading";
    },
    [USERS_ITEMS_NEEDING_ATTENTION]: state => {
        state.status = "loading";
    },
    [USERS_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "users", resp.payload);
    },
    [USERS_ITEMS_SUCCESS]: (state, resp) => {
        state.status = "success";
        Vue.set(state, "items", resp.payload);
    },
    [USERS_ERROR]: state => {
        state.status = "error";
    },
    [USERS_ITEMS_ERROR]: state => {
        state.status = "error";
    },
    [USER_CHECKIN_RETRIEVE_ACTIVE]: state => {
        state.status = "loading";
    },
    [USER_CHECKIN_RETRIEVE_ACTIVE_SUCCESS]: state => {
        state.status = "success";
    },
    [USER_CHECKIN_RETRIEVE_ACTIVE_ERROR]: state => {
        state.status = "error";
    },
    [AUTHTOKEN_LOGOUT]: state => {
        state.user = null;
    },
    [INDUCTIONS_REQUEST]: state => {
        state.status = "loading";
    },
    [INDUCTIONS_SITE_REQUEST]: state => {
        state.status = "loading";
    },
    [INDUCTIONS_USER_REQUEST]: state => {
        state.status = "loading";
    },
    [INDUCTIONS_SUCCESS]: (state) => {
        state.status = "success";
    //    Vue.set(state, "inductions", resp.payload);
    },
    [INDUCTIONS_ERROR]: state => {
        state.status = "error";
    },
    [INDUCTION_CREATE]: state => {
        state.status = "loading";
    },
    [INDUCTION_DELETE]: state => {
        state.status = "loading";
    },
    [INDUCTION_UPDATE]: state => {
        state.status = "loading";
    },





};

export default {
    state,
    getters,
    actions,
    mutations
};